// extracted by mini-css-extract-plugin
export default {"container":"NavSidebar_container__5xrve","item":"NavSidebar_item__g0UnZ"};